/* eslint-disable vue/multi-word-component-names */

<template>
  <main class="collection">
    <div class="speech-bubble speech-bubble--margin" v-if="filter == null">all</div>
    <div class="speech-bubble speech-bubble--margin" v-else>{{ filter }}</div>
    <router-link
      class="collection__item"
      v-for="(product, index) in filteredProducts"
      :key="index"
      :to="'/products/' + product.id"
    >
      <img
        :src="product.collectionImgUrl"
        :alt="product.collectionImgAlt"
        class="collection__item-img"
      >
      <section class="collection__item-copy">
        <h1 class="collection__item-title">{{ product.productTitle }}</h1>
        <p class="collection__item-keyword">{{ product.keywords }}</p>
      </section>
    </router-link>
    <div v-if="filteredProducts == 0" class="error">
      <h2>
        Sorry, there were no results found for
        <i>{{ filter }}</i>. Please try another search.
      </h2>
    </div>
  </main>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      products: [],
      search: "",
      filter: this.$route.params.filter
    };
  },
  created() {
    const vm = this;
    this.axios.get("/db.json").then(data => {
      vm.products = data.data;
    });
  },
  computed: {
    filteredProducts: function() {
      return this.products.filter(product => {
        // console.log(this.filter);
        if (!this.filter) {
          // console.log("1");
          return true;
        }
        if (product.keywords.toLowerCase().indexOf(this.filter) > -1) {
          // console.log("2");
          return true;
        }
        if (product.productTitle.toLowerCase().indexOf(this.filter) > -1) {
          // console.log("3");
          return true;
        }
        if (this.filter == 0) {
          // console.log("no search results");
        }
        // console.log("4");
        return false;
      });
    }
  },
  beforeRouteUpdate(to, from, next) {
    // just use `this`
    this.filter = to.params.filter;
    next();
    //updates title again when filter is changed
    document.title = `mjccreative | ${this.filter}`;
  },
  title() {
    return `mjccreative | ${this.filter}`;
  }
};
</script>

<style lang="scss" scoped>
@use "../assets/scss/_siteVariables";

.collection {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  &__item {
    text-decoration: none;
    display: flex;
    flex: 0 0 100%;
    flex-direction: column;
    align-items: center;
    padding-right: 15px;
    padding-left: 15px;
    @media (min-width: 576px) {
      flex: 0 0 50%;
      max-width: 50%;
    }
    @media (min-width: 768px) {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
    }
    @media (min-width: 1000px) {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
  &__item-img {
    width: 100%;
    height: auto;
    outline: 1px solid var(--light-grey);
    //controls animation for on hover
    transition-delay: 0ms;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    border-radius: 10px;
    // box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.1);
    &:hover {
      transform: translateY(-5px);
    }
  }
  &__item-copy {
    width: 100%;
  }
  &__item-title {
    font-size: 17px;
    color: var(--darkest-grey);
    margin: 15px 0 5px 0;
    display: inline-block;
    &:hover {
      color: var(--accent);
    }
    &::after {
      content: "";
      display: block;
      width: 0px;
      height: 1px;
      bottom: 0;
      background-color: var(--accent);
      transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    }
    &:hover::after {
      width: 100%;
    }
  }
  &__item-keyword {
    color: var(--darkest-grey);
    font-size: 14px;
    margin: 5px 0 30px 0;
  }
}

/* Keyframes for the fade-in */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.error {
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  // fixes sorry error when page first loads before db kicks in
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 0.1s;
  -moz-animation-duration: 0.1s;
  animation-duration: 0.1s;

  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}
</style>
